import { Button } from "@nextui-org/react";
import React from "react";
import CashKarmaLogo from "../../../component/Icons/CashKarma/CashKarmaLogo";
import SuccessConfirmationIcon from "../../../component/Icons/CashKarma/SuccessConfirmationIcon.js";
import * as UrlUtil from "../../../util/UrlUtil.js";
import * as ConfigUtil from "../../../util/ConfigUtil.js";
import ButtonOpenApp from "component/PageComponents/ButtonOpenApp.js";

let APPLICATION_NAME = "cashkarma";

export default function ResetConfirmation() {
  return (
    <div
      className="h-screen flex flex-col items-center justify-center overflow-scroll font-fira"
      style={{ backgroundColor: "#FFF6EB" }}>
      <div className="mb-4">
        <CashKarmaLogo />
      </div>
      <div
        className="lg:w-1/3 md:w-1/2 w-96 flex items-center justify-center p-4 rounded-lg"
        style={{ backgroundColor: "#FFFFFF", border: '2px solid #FF7400', borderRadius: '50px' }}>
        <div className="rounded-md p-2 w-full">
          <div className="flex justify-center">
            <div>
              <SuccessConfirmationIcon />
            </div>
          </div>
          <div className="text-center p-4 text-white">
            <div className="text-[#212121] text-2xl font-fira font-extrabold">Password Reset Successfully</div>
            <div className="text-[#424242] text-sm mt-4 font-montserrat">
              You can log in with your new password
            </div>
          </div>
          <div className="px-3">
            <ButtonOpenApp applicationName={APPLICATION_NAME} />
          </div>
        </div>
      </div>
    </div>
  );
}
